import { ReactNode} from "react";
import { Container } from "react-bootstrap";

export default function HeroBanner({children, containerClassName} : {children : ReactNode, containerClassName? : string}){
    return(
        <div className={`${containerClassName ? containerClassName : 'bg-navy'}`}>
            <Container className={`text-center container-fluid `}>
                {children}
            </Container>
        </div>
    )
}